import { Stack } from "@mui/material";
import { ReactNode } from "react";

import AuthorizedElement from "@/common/components/Auth/AuthorizedElement";
import AppIconButton from "@/common/components/Button/AppIconButton";
import AppIcon from "@/common/components/Icons/AppIcon";
import AppTooltip from "@/common/components/Tooltip/AppTooltip";
import { AppPermission, BaseEntityDto, GeneralStatusMetaDto } from "@/core/api/generated/v1";

import GeneralStatusEnumValueInline from "./GeneralStatusEnumValueInline";
import GeneralStatusMetaDetailsPopover, {
  GeneralStatusMetaDetailsPopoverProps,
} from "./GeneralStatusMetaDetailsPopover";

export interface GeneralStatusMetaDisplayProps {
  value: GeneralStatusMetaDto | undefined | null;
  subjectEntity: BaseEntityDto | undefined;
  withDetailsPopover?: boolean;
  detailsPopoverProps?: Partial<GeneralStatusMetaDetailsPopoverProps>;
  mainContent?: ReactNode;
  onMetaUpdated: (newValue: GeneralStatusMetaDto) => void;
}

export default function GeneralStatusMetaDisplay({
  value,
  subjectEntity,
  withDetailsPopover = true,
  detailsPopoverProps,
  mainContent,
  onMetaUpdated,
}: GeneralStatusMetaDisplayProps) {
  if (!value) {
    return null;
  }

  return (
    <Stack direction='row' spacing={0.5} sx={{ alignItems: "center" }}>
      {mainContent || (
        <GeneralStatusEnumValueInline
          statusEnumTypeName={value.statusEnumTypeName}
          status={value.status}
        />
      )}

      {withDetailsPopover && (
        <AuthorizedElement permissions={[AppPermission.GeneralStatusHistoryRead]}>
          <GeneralStatusMetaDetailsPopover
            {...detailsPopoverProps}
            clickBehavior={{}}
            trigger={
              <AppTooltip title='View details'>
                <AppIconButton size='extraSmall' sx={{ ml: 0.25 }}>
                  <AppIcon of='details' />
                </AppIconButton>
              </AppTooltip>
            }
            value={value}
            subjectEntity={subjectEntity}
            onMetaUpdated={onMetaUpdated}
          />
        </AuthorizedElement>
      )}
    </Stack>
  );
}
